// src/app/shell/sidebar/app-sidebar.component.ts
import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { DecimalPipe } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { NavigationService } from '../../core/navigation/navigation.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterModule, LucideAngularModule, DecimalPipe],
  template: `
    <div class="h-full overflow-y-auto py-4 px-3"
         style="background: hsl(var(--sidebar-background));">
      @if (nav.activeSectionConfig(); as section) {
        <!-- Section heading -->
        <h2 class="text-sm font-semibold uppercase tracking-wider px-2 pb-3"
            style="color: hsl(var(--sidebar-muted));">
          {{ section.label }}
        </h2>

        <!-- Top-level children -->
        @for (item of section.children; track item.path) {
          <button (click)="navigate(item.path)"
                  class="w-full flex items-center gap-3 px-3 py-2 rounded-md text-sm mb-1 transition-colors text-left"
                  [style]="router.url === item.path
                    ? 'background: hsl(var(--sidebar-accent)); color: hsl(var(--sidebar-accent-foreground));'
                    : 'color: hsl(var(--sidebar-foreground));'">
            <lucide-icon [img]="item.icon" [size]="16" class="shrink-0" />
            <span>{{ item.label }}</span>
          </button>
        }

        <!-- Groups -->
        @for (group of section.groups; track group.groupLabel) {
          <div class="mt-4 mb-1">
            <h3 class="text-[10px] font-semibold uppercase tracking-widest px-3 pb-1"
                style="color: hsl(var(--sidebar-muted));">
              {{ group.groupLabel }}
            </h3>
            @for (item of group.items; track item.path) {
              <button (click)="navigate(item.path)"
                      class="w-full flex items-center gap-3 px-3 py-2 rounded-md text-sm mb-0.5 transition-colors text-left"
                      [style]="router.url === item.path
                        ? 'background: hsl(var(--sidebar-accent)); color: hsl(var(--sidebar-accent-foreground));'
                        : 'color: hsl(var(--sidebar-foreground));'">
                <lucide-icon [img]="item.icon" [size]="16" class="shrink-0" />
                <span class="flex-1">{{ item.label }}</span>
                @if (item.badge !== undefined) {
                  <span class="ml-auto text-[10px] font-semibold rounded-full px-1.5 py-0.5 min-w-[20px] text-center"
                        style="background: hsl(var(--sidebar-accent)); color: hsl(var(--sidebar-accent-foreground))">
                    {{ item.badge | number }}
                  </span>
                }
              </button>
            }
          </div>
        }
      }
    </div>
  `,
})
export class AppSidebarComponent {
  readonly nav = inject(NavigationService);
  readonly router = inject(Router);

  navigate(path: string): void {
    this.router.navigate([path]);
  }
}
